import { render, staticRenderFns } from "./customerSalesTable.vue?vue&type=template&id=35474721&scoped=true"
import script from "./customerSalesTable.vue?vue&type=script&lang=js"
export * from "./customerSalesTable.vue?vue&type=script&lang=js"
import style0 from "./customerSalesTable.vue?vue&type=style&index=0&id=35474721&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35474721",
  null
  
)

export default component.exports